let ENV = process.env.NODE_ENV || 'development';

let { baseOrigin } = require(`./env.${ENV}`);

export {
    baseOrigin
};